<template>
  <div class="privilegeBtn">
    <div class="privilegeBtn_item">
      <el-switch class="privilegeBtn_swtich" v-model="isPrivilegeSwitch" active-text="权限编辑"
        @change="changeSwitch('isPrivilege')" />
      <el-button class="privilegeBtn_save" type="success" @click="copyStr">{{$ts('复制')}}</el-button>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapMutations,
  } from 'vuex'
  import {
    debounceFn
  } from '@/assets/js/tool.js'
  export default {
    data() {
      return {
        isPrivilegeSwitch: false,
        privilegeJson: ''
      }
    },
    computed: {
      ...mapState(['isPrivilege', 'platPrivilege']),
    },
    watch: {
      isPrivilege: {
        immediate: true,
        handler(val) {
          this.isPrivilegeSwitch = val;
        }
      }
    },
    methods: {
      ...mapMutations(['SET_STATE']),
      changeSwitch(type) {
        let obj = {};
        obj[type] = this[type + 'Switch'];
        this.SET_STATE(obj)
      },
      copyStr() {
        let str = JSON.stringify(this.platPrivilege);
        this.$copyText(str).then(() => {
          this.$message.success(this.$ts('复制成功'))
        }).catch(() => {
          this.$message.error(this.$ts('复制失败'))
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .privilegeBtn {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    &_item {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      margin-right: 10px;
    }

    &_save {
      margin-left: 10px;
    }

    &_swtich {
      flex-shrink: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/PrivilegeBtn.vue